// src/api/apiProducts.js
import axios from "../utils/axios";

// Get Products (with pagination & filters)
export const getAllProducts = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("products", { params });
    return data;
};

// Get Products for Select Dropdown
export const getProductsForSelect = async () => {
    const { data } = await axios.get("products/for-select");
    return data;
};

// Get Single Product
export const getProduct = async (id) => {
    if (!id) return null;
    const { data } = await axios.get(`products/${id}`);
    return data;
};

// Create Product
export const createProduct = async (req) => {
    try {
        const { data } = await axios.post("products", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createProduct error:", error);
        throw error;
    }
};

// Update Product
export const updateProduct = async (req, id) => {
    try {
        const { data } = await axios.put(`products/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updateProduct error:", error);
        throw error;
    }
};

// Soft Delete Product
export const deleteProduct = async (id) => {
    try {
        const { data } = await axios.delete(`products/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteProduct error:", error);
        throw error;
    }
};

// Mass Soft Delete Products
export const deleteAllProducts = async (req = []) => {
    try {
        const { data } = await axios.delete("products/mass-destroy", {
            data: req,
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteAllProducts error:", error);
        throw error;
    }
};

// Force Delete Product
export const forceDeleteProduct = async (id) => {
    try {
        const { data } = await axios.delete(`products/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteProduct error:", error);
        throw error;
    }
};

// Mass Force Delete Products
export const forceDeleteAllProducts = async (ids = []) => {
    try {
        const { data } = await axios.delete("products/mass-force-delete", {
            data: ids,
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteAllProducts error:", error);
        throw error;
    }
};

// Restore Product
export const restoreProduct = async (id) => {
    try {
        const { data } = await axios.post(`products/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreProduct error:", error);
        throw error;
    }
};

// Mass Restore Products
export const restoreAllProducts = async (req = []) => {
    try {
        const { data } = await axios.post("products/mass-restore", { ...req }, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreAllProducts error:", error);
        throw error;
    }
};
